import React, { useMemo } from 'react'
import styles from './styles.module.css'
import ReactSelect from 'react-select'
import { Input } from '../../../components/ModalInputs'
import cn from 'classnames'

const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '32px',
        fontSize: '15px',
        borderColor: state.isFocused ? '#274684' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #274684' : 'none',
        '&:hover': { borderColor: '#274684' }
    }),
    option: (base) => ({
        ...base,
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        fontSize: '14px',
        padding: '8px 12px'
    }),
    menu: (base) => ({
        ...base,
        zIndex: 100
    }),
    placeholder: (base) => ({
        ...base,
        color: '#999'
    })
}

const Planning = ({ lesson, lessonData, handleLessonDataChange, eventTypes, weights, themes, trials, teachers = [], errors = {} }) => {

    const handleRowClick = (oid) => {
        handleLessonDataChange('module_id', oid)
    }

    const eventTypeOptions = useMemo(() => [
        { value: null, label: 'Выберите тип' },
        ...(eventTypes?.map(type => ({ value: type.typeid, label: type.typename })) || [])
    ], [eventTypes])

    const trialOptions = useMemo(() => [
        { value: 0, label: 'Нет' },
        ...(trials?.map(t => ({ value: t.id, label: t.name })) || [])
    ], [trials])

    const weightOptions = useMemo(() =>
        weights?.map(w => ({ value: w.weight ?? w, label: String(w.weight ?? w) })) || []
    , [weights])

    const teacherOptions = useMemo(() =>
        teachers?.map(t => ({ value: t.mid, label: t.fio })) || []
    , [teachers])

    const selectedEventType = eventTypeOptions.find(opt => opt.value === lessonData.event_type) || eventTypeOptions[0]
    const selectedTeacher = teacherOptions.find(opt => opt.value === lessonData.teacher_mid) || null
    const selectedTrial = trialOptions.find(opt => opt.value === lessonData.trial) || trialOptions[0]
    const selectedWeight = weightOptions.find(opt => opt.value === lessonData.default_weight) || weightOptions[0]

    return (
        <>
            <div className={styles.wrapperPlanning}>
                <div className={styles.headerInfo}>
                    <span className={styles.infoLabel}>Предмет:</span>
                    <span className={styles.infoValue}>
                        {lesson?.course_title || ''}{lesson?.class_name ? `, класс - ${lesson.class_name}` : ''}
                    </span>
                </div>

                <div className={styles.planningRow}>
                    <div className={styles.selectGroup}>
                        <label>Преподаватель</label>
                        <ReactSelect
                            options={teacherOptions}
                            value={selectedTeacher}
                            onChange={opt => handleLessonDataChange('teacher_mid', opt?.value)}
                            styles={selectStyles}
                            placeholder="Выберите преподавателя"
                            className={styles.reactSelect}
                        />
                    </div>

                    <div className={styles.selectGroup}>
                        <label className={errors.event_type ? styles.labelError : ''}>Тип занятия *</label>
                        <ReactSelect
                            options={eventTypeOptions}
                            value={selectedEventType}
                            onChange={opt => handleLessonDataChange('event_type', opt?.value)}
                            styles={selectStyles}
                            placeholder="Выберите тип"
                            className={styles.reactSelect}
                        />
                        {errors.event_type && <span className={styles.errorText}>{errors.event_type}</span>}
                    </div>

                    <div className={styles.inputGroup}>
                        <label>Количество работ</label>
                        <Input
                            type='number'
                            min={1}
                            value={lessonData.work_count || 1}
                            onChange={e => handleLessonDataChange('work_count', Number(e.target.value))}
                        />
                    </div>

                    {/* <div className={styles.selectGroup}>
                        <label>Тестовое задание</label>
                        <ReactSelect
                            options={trialOptions}
                            value={selectedTrial}
                            onChange={opt => handleLessonDataChange('trial', opt?.value ?? 0)}
                            styles={selectStyles}
                            placeholder="Нет"
                            className={styles.reactSelectWide}
                        />
                    </div>

                    <div className={styles.selectGroup}>
                        <label>Вес оценок по умолчанию</label>
                        <ReactSelect
                            options={weightOptions}
                            value={selectedWeight}
                            onChange={opt => handleLessonDataChange('default_weight', opt?.value ?? 1)}
                            styles={selectStyles}
                            className={styles.reactSelectSmall}
                        />
                    </div> */}
                </div>


                <div className={errors.module_id ? styles.themeLabelError : styles.themeLabel}>
                    Тема занятия *{errors.module_id && <span className={styles.errorText}> — выберите строку в таблице ниже</span>}
                </div>
            </div>

            <div className={styles.themesTableWrapper}>
                <table className={styles.themesTableCustom}>
                    <thead>
                        <tr>
                            <th style={{ width: '50%' }}>Содержание курса</th>
                            <th style={{ width: '15%' }}>№ урока</th>
                            <th style={{ width: '15%' }}>Кол-во часов</th>
                            <th style={{ width: '20%' }}>Планируемые результаты</th>
                        </tr>
                    </thead>
                    <tbody>
                        {themes?.length > 0 ? (
                            themes.map(item => (
                                <tr
                                    key={item.oid}
                                    className={cn(styles.themeRow, {
                                        [styles.themeRowSelected]: lessonData.module_id === item.oid
                                    })}
                                    onClick={() => handleRowClick(item.oid)}
                                >
                                    <td style={{ paddingLeft: `${(item.level || 0) * 20 + 8}px` }}>
                                        {item.title}
                                    </td>
                                    <td>{item.nr}</td>
                                    <td>{item.hrs}</td>
                                    <td>{item.expected_result}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} className={styles.emptyMessage}>Нет данных</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className={styles.planningFooter}>
                <div className={styles.footerInfo}>
                    <span>Итого по часам: {lesson?.total_hours || 0}</span>
                    <span>Учебный план: {lesson?.plan_hours || 0}</span>
                </div>
            </div>
        </>
    )
}

export default Planning
